import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaClock } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you! We will contact you soon.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const contactInfo = [
    {
      icon: <FaPhone />,
      title: 'Phone',
      detail: '+91 98765 43210',
      link: 'tel:+919876543210'
    },
    {
      icon: <FaWhatsapp />,
      title: 'WhatsApp',
      detail: '+91 98765 43210',
      link: 'https://wa.me/919876543210'
    },
    {
      icon: <FaEnvelope />,
      title: 'Email',
      detail: 'info@jeevikproperty.com',
      link: 'mailto:info@jeevikproperty.com'
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Location',
      detail: 'Opposite Wellness Forever, Vasai West, Mumbai',
      link: 'https://maps.google.com'
    },
    {
      icon: <FaClock />,
      title: 'Working Hours',
      detail: 'Mon-Sat: 10 AM - 7 PM',
      link: null
    }
  ];

  return (
    <section className="contact section-padding" id="contact">
      <div className="container">
        <div className="section-title">
          <h2>Get In Touch</h2>
          <p>We're Here to Help You Find Your Perfect Property</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Contact Information</h3>
            <p className="contact-desc">
              Reach out to us for any property-related queries. Our team is ready to assist you.
            </p>

            <div className="info-list">
              {contactInfo.map((info, index) => (
                <div className="info-item" key={index}>
                  <div className="info-icon">{info.icon}</div>
                  <div className="info-details">
                    <h4>{info.title}</h4>
                    {info.link ? (
                      <a href={info.link} target="_blank" rel="noopener noreferrer">
                        {info.detail}
                      </a>
                    ) : (
                      <p>{info.detail}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="contact-form">
            <h3>Send Us a Message</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name *"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Your Phone *"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Your Message *"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button type="submit" className="btn-primary">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;